export default __webpack_public_path__ + "static/media/kpronounce.ba7a4126.png";